export default "__VITE_ASSET__BSFt0bwq__"